module.exports = __webpack_public_path__ + "static/img/planning.484d294c.png";